import { SapCostEstimate } from "libs/sap/src/lib/models/sap.model";
import { FUNCTIONAL_CANCELLATION_PRICE, PROFESSIONAL_CANCELLATION_PRICE } from "libs/sap/src/lib/services/sap.fixed-prices.constants";

export const FUNCTIONAL_CANCELLATION_COST_ESTIMATE: SapCostEstimate = {
	ItemPriceSum: FUNCTIONAL_CANCELLATION_PRICE,
	DiscountedItemPriceSum: FUNCTIONAL_CANCELLATION_PRICE,
	DiscountFactor: 1,
	ShippingCost: 0,
	Vat: 0,
	Total: FUNCTIONAL_CANCELLATION_PRICE
}

export const PROFESSIONAL_CANCELLATION_COST_ESTIMATE: SapCostEstimate = {
	ItemPriceSum: PROFESSIONAL_CANCELLATION_PRICE,
	DiscountedItemPriceSum: PROFESSIONAL_CANCELLATION_PRICE,
	DiscountFactor: 1,
	ShippingCost: 0,
	Vat: 0,
	Total: PROFESSIONAL_CANCELLATION_PRICE
}
